import { PAYMENT_LINKS } from "@/lib/api";

export default function PaymentButtons() {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
      <a
        href={PAYMENT_LINKS.revolut}
        target="_blank"
        rel="noreferrer"
        data-testid="pay-revolut-btn"
        className="inline-flex h-11 items-center justify-center rounded-md bg-[#0075EB] px-5 text-sm font-medium text-white transition-all hover:bg-[#0066d1]"
      >
        Pay with Revolut
      </a>
      <a
        href={PAYMENT_LINKS.paypal}
        target="_blank"
        rel="noreferrer"
        data-testid="pay-paypal-btn"
        className="inline-flex h-11 items-center justify-center rounded-md bg-[#003087] px-5 text-sm font-medium text-white transition-all hover:bg-[#002066]"
      >
        Pay with PayPal
      </a>
    </div>
  );
}
